// extracted by mini-css-extract-plugin
module.exports = {"titleCaseHeader":"style_titleCaseHeader__ZkVf7","titleCaseHeader__title":"style_titleCaseHeader__title__5YuII","titleCaseHeader__subtitle":"style_titleCaseHeader__subtitle__P_muX"};